module.exports = __webpack_public_path__ + "static/section3-520c43494a0dcc46db32eaa2c118916d.svg";